"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfJoinWaitlistDto = instanceOfJoinWaitlistDto;
exports.JoinWaitlistDtoFromJSON = JoinWaitlistDtoFromJSON;
exports.JoinWaitlistDtoFromJSONTyped = JoinWaitlistDtoFromJSONTyped;
exports.JoinWaitlistDtoToJSON = JoinWaitlistDtoToJSON;
exports.JoinWaitlistDtoToJSONTyped = JoinWaitlistDtoToJSONTyped;
/**
 * Check if a given object implements the JoinWaitlistDto interface.
 */
function instanceOfJoinWaitlistDto(value) {
    if (!('email' in value) || value['email'] === undefined)
        return false;
    return true;
}
function JoinWaitlistDtoFromJSON(json) {
    return JoinWaitlistDtoFromJSONTyped(json, false);
}
function JoinWaitlistDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'email': json['email'],
    };
}
function JoinWaitlistDtoToJSON(json) {
    return JoinWaitlistDtoToJSONTyped(json, false);
}
function JoinWaitlistDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'email': value['email'],
    };
}
